export const isSupportUser = () => localStorage.getItem('user_role') === 'support';
